import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getVehicleSummaryStats = async (brandId, modelId, yearId = null, versionId = null, context = {}) => {
  if (!brandId || !modelId || (!context.activeUnitId && !context.dealershipId)) {
    return null;
  }

  try {
    const getSummaryFn = httpsCallable(functions, 'getVehicleSummaryStatsV2');
    const result = await getSummaryFn({
      brandId,
      modelId,
      yearId,
      versionId,
      operatingUnitId: context.activeUnitId,
      dealershipId: context.dealershipId,
      requestedApp: 'dealership_web',
    });

    if (result.data) {
      if (result.data.success === 'yes') {
        return result.data.data;
      }
      if (result.data.success === undefined) {
        return result.data;
      }
    }
    return null;
  } catch (error) {
    console.error('Error obteniendo resumen de estadísticas:', error);
    notifyPermissionDenied(error);
    return null;
  }
};
